import { useI18n } from "@wojo/localization";
import { RadioButtonGroup, Text } from "@wojo/ui";
import { useId } from "react";
import { useWeatherContext } from "../../_client/context";
import styles from "./Buttons.module.scss";

export const TemperatureButtons: React.FC = () => {
    const { productPage } = useI18n("productPage");
    const { isCustomary, setIsCustomary } = useWeatherContext();
    const groupId = useId();

    return (
        <RadioButtonGroup
            title={
                <Text className="visually-hidden">
                    {productPage.weather.temperatureScale.l()}
                </Text>
            }
            hideRequired
            variant={"column"}
            name={groupId}
            items={[
                { label: "\u{B0}F", value: "fahrenheit" },
                { label: "\u{B0}C", value: "celsius" },
            ]}
            checkedValue={isCustomary ? "fahrenheit" : "celsius"}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setIsCustomary(e.currentTarget.value === "fahrenheit");
            }}
            radioButtonWrapperClassname={styles["radio-button-wrapper"]}
        />
    );
};
